import React from "react"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"


type OwnProps = {
    messageId : string
    backgroundColor? : string
    type : string
    value : string
    currency? : string
}



const Panel = (props: OwnProps) => {

    const backgroundColor = props.backgroundColor || "bg-dark"

    switch (props.type) {
    case "moneyTotal" :
        return (
            <div className={`px-3 mr-1 ${backgroundColor}`}>
                <div className={"w-100"}>
                    <label className="col-form-label custom-form-label pt-2 text-white">
                        <strong>
                            <FormattedMessage
                                id={props.messageId}
                            />
                        </strong>
                    </label>
                </div>
                <h2 className={"m-0 text-white border-bottom-0"}>
                    <FormattedNumber
                        value={props.value}
                        style={"currency"}
                        currency={props.currency}
                    />
                </h2>
            </div>
        )
    }
}
export default injectIntl(Panel)


// WEBPACK FOOTER //
// ./src/common/container/Panel.tsx